"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _usageTracking = require("rich-text-lib/constants/usageTracking");

var _SmallToggleButton = _interopRequireDefault(require("../components/SmallToggleButton"));

var _constants = require("../lib/constants");

var _usageTracker = require("../tracking/usageTracker");

var _handleListTabs = _interopRequireDefault(require("../utils/handleListTabs"));

var Tracker;
var LIST_TYPES_TO_TRACKING_ACTIONS = {
  'ordered-list-item': _usageTracking.MAKE_ORDERED_LIST,
  'unordered-list-item': _usageTracking.MAKE_UNORDERED_LIST
};

var getTrackingData = function getTrackingData(style) {
  var listTrackingAction = LIST_TYPES_TO_TRACKING_ACTIONS[style];

  if (listTrackingAction) {
    return {
      action: listTrackingAction,
      method: 'toolbar'
    };
  }

  return {
    action: _usageTracking.CHANGE_BLOCK_FORMAT,
    method: 'toolbar',
    value: style
  };
};

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$listStyles = _ref.listStyles,
      listStyles = _ref$listStyles === void 0 ? null : _ref$listStyles,
      _ref$headerStyles = _ref.headerStyles,
      headerStyles = _ref$headerStyles === void 0 ? null : _ref$headerStyles,
      _ref$miscStyles = _ref.miscStyles,
      miscStyles = _ref$miscStyles === void 0 ? null : _ref$miscStyles;

  if (!Tracker) {
    Tracker = (0, _usageTracker.createTracker)();
  }

  var createBlockStyleButton = function createBlockStyleButton(_ref2) {
    var label = _ref2.label,
        style = _ref2.style,
        name = _ref2.name,
        icon = _ref2.icon;

    var tooltip = _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.blockStyle.tooltips." + name
    });

    var BlockStyleButton = (0, _createReactClass.default)({
      displayName: "BlockStyleButton",
      propTypes: {
        disabled: _propTypes.default.bool,
        editorState: _propTypes.default.object,
        onChange: _propTypes.default.func
      },
      getDefaultProps: function getDefaultProps() {
        return {
          disabled: false
        };
      },
      handleToggleStyle: function handleToggleStyle() {
        var _this$props = this.props,
            editorState = _this$props.editorState,
            onChange = _this$props.onChange;

        var newState = _draftJs.RichUtils.toggleBlockType(editorState, style);

        onChange(_draftJs.EditorState.forceSelection(newState, newState.getSelection()));
        Tracker.track('draftFormatting', getTrackingData(style.toLowerCase()));
      },
      render: function render() {
        var _this$props2 = this.props,
            editorState = _this$props2.editorState,
            disabled = _this$props2.disabled;
        var currentBlockStyle = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();
        var isStyleActive = currentBlockStyle === style;
        var btnClass = (0, _classnames.default)('draft-toolbar-button', style ? style.toLowerCase() + "-button" : '');
        var isButtonActive = !disabled && isStyleActive;
        return _react.default.createElement(_SmallToggleButton.default, {
          active: isButtonActive,
          className: btnClass,
          disabled: disabled,
          label: label,
          icon: icon,
          onClick: this.handleToggleStyle,
          tooltip: tooltip
        });
      }
    });
    return BlockStyleButton;
  };

  var buttons = [];

  if (Array.isArray(listStyles)) {
    var styles = _constants.LIST_TYPES.filter(function (style) {
      return listStyles.indexOf(style.style) !== -1;
    });

    buttons.push.apply(buttons, (0, _toConsumableArray2.default)(styles.map(createBlockStyleButton)));
  } else {
    buttons.push.apply(buttons, (0, _toConsumableArray2.default)(_constants.LIST_TYPES.map(createBlockStyleButton)));
  }

  if (Array.isArray(headerStyles)) {
    var _styles = _constants.HEADER_TYPES.filter(function (style) {
      return headerStyles.indexOf(style.style) !== -1;
    });

    buttons.push.apply(buttons, (0, _toConsumableArray2.default)(_styles.map(createBlockStyleButton)));
  } else {
    buttons.push.apply(buttons, (0, _toConsumableArray2.default)(_constants.HEADER_TYPES.map(createBlockStyleButton)));
  }

  if (Array.isArray(miscStyles)) {
    var _styles2 = _constants.MISC_TYPES.filter(function (style) {
      return miscStyles.indexOf(style.style) !== -1;
    });

    buttons.push.apply(buttons, (0, _toConsumableArray2.default)(_styles2.map(createBlockStyleButton)));
  } else {
    buttons.push.apply(buttons, (0, _toConsumableArray2.default)(_constants.MISC_TYPES.map(createBlockStyleButton)));
  }

  return (0, _draftExtend.createPlugin)({
    keyCommandListener: _handleListTabs.default,
    buttons: buttons,
    displayName: 'BlockStyles',
    blockToHTML: function blockToHTML(block) {
      switch (block.type) {
        case 'blockquote':
          return _react.default.createElement("blockquote", null);

        case 'code-block':
          return _react.default.createElement("pre", null);

        default:
          return undefined;
      }
    }
  });
};

exports.default = _default;
module.exports = exports.default;